import { ArrowRight } from "lucide-react";
import { Link } from "react-router-dom";
import { Seo } from "../components/Seo";
import { Reveal } from "../components/Reveal";
import { CTABand } from "../components/CTABand";
import { useLang } from "../i18n";

export default function Struttura() {
  const { l, data, t } = useLang();
  const { IMAGES } = data;
  const s = t.structure;

  return (
    <>
      <Seo title={s.seo.title} description={s.seo.description} path="/la-struttura" />
      <section className="max-w-7xl mx-auto px-5 md:px-10 pt-32 md:pt-44 pb-16 md:pb-24">
        <Reveal>
          <p className="eyebrow mb-5">{s.eyebrow}</p>
          <h1 className="font-serif text-4xl sm:text-5xl lg:text-6xl leading-tight text-ink max-w-3xl">
            {s.h1}
          </h1>
        </Reveal>
        <Reveal delay={0.12}>
          <p className="mt-8 text-base md:text-lg text-body leading-relaxed max-w-2xl">
            {s.lead}
          </p>
        </Reveal>
      </section>

      <section className="max-w-7xl mx-auto px-5 md:px-10 grid grid-cols-1 md:grid-cols-12 gap-8 md:gap-12 pb-20 md:pb-28 items-start">
        <Reveal className="md:col-span-7">
          <div className="img-frame aspect-[4/3]">
            <img src={IMAGES.facade} alt={s.s1.alt} loading="lazy" className="w-full h-full object-cover" />
          </div>
        </Reveal>
        <Reveal delay={0.12} className="md:col-span-5 md:pt-16">
          <h2 className="font-serif text-2xl md:text-3xl text-ink">{s.s1.title}</h2>
          <p className="mt-5 text-sm md:text-base text-body leading-relaxed">
            {s.s1.text}
          </p>
          <Link
            to={l("/camere")}
            data-testid="structure-rooms-link"
            className="mt-6 inline-flex items-center gap-2 text-sm font-semibold text-sage border-b border-sage/40 pb-1 transition-colors duration-300 hover:text-terra hover:border-terra"
          >
            {s.s1.link} <ArrowRight className="w-4 h-4" />
          </Link>
        </Reveal>
      </section>

      <section className="bg-surface border-y border-sand">
        <div className="max-w-7xl mx-auto px-5 md:px-10 py-20 md:py-28 grid grid-cols-1 md:grid-cols-12 gap-10">
          <Reveal className="md:col-span-5">
            <div className="img-frame aspect-[3/4]">
              <img src={IMAGES.reception} alt={s.s2.alt} loading="lazy" className="w-full h-full object-cover" />
            </div>
          </Reveal>
          <div className="md:col-span-6 md:col-start-7 flex flex-col justify-center">
            <Reveal>
              <h2 className="font-serif text-2xl md:text-4xl text-ink leading-snug">
                {s.s2.title}
              </h2>
            </Reveal>
            <Reveal delay={0.1}>
              <p className="mt-6 text-sm md:text-base text-body leading-relaxed">
                {s.s2.p1}
              </p>
              <p className="mt-4 text-sm md:text-base text-body leading-relaxed">
                {s.s2.p2}
              </p>
            </Reveal>
          </div>
        </div>
      </section>

      <section className="max-w-7xl mx-auto px-5 md:px-10 py-20 md:py-28 grid grid-cols-1 md:grid-cols-12 gap-10 items-center">
        <div className="md:col-span-6 order-2 md:order-1">
          <Reveal>
            <h2 className="font-serif text-2xl md:text-4xl text-ink leading-snug">
              {s.s3.title}
            </h2>
          </Reveal>
          <Reveal delay={0.1}>
            <p className="mt-6 text-sm md:text-base text-body leading-relaxed">
              {s.s3.text}
            </p>
          </Reveal>
          <Reveal delay={0.16}>
            <Link
              to={l("/il-territorio")}
              data-testid="structure-territory-link"
              className="mt-7 inline-flex items-center gap-2 text-sm font-semibold text-sage border-b border-sage/40 pb-1 transition-colors duration-300 hover:text-terra hover:border-terra"
            >
              {s.s3.link} <ArrowRight className="w-4 h-4" />
            </Link>
          </Reveal>
        </div>
        <Reveal delay={0.1} className="md:col-span-5 md:col-start-8 order-1 md:order-2">
          <div className="img-frame aspect-[4/5]">
            <img src={IMAGES.garden} alt={s.s3.alt} loading="lazy" className="w-full h-full object-cover" />
          </div>
        </Reveal>
      </section>

      <CTABand />
    </>
  );
}
